export const CreatorHeaderHeightPxMobile = 64;
export const CreatorHeaderHeightPxDesktop = 80;
export const CreatorBannerHeight = 68;
